<template>
  <div class="home">
    <ProgressStep step=1 />
    <p class="stepReminder">Étape 1/4</p>
    <h1>Revenus de la famille</h1>
    <p>
      Entre ici le montant du <b>revenu brut global</b> indiqué dans
      l’avis d’imposition {{ new Date().getFullYear() -1 }} à la page 2.
    </p>
    <div class="inputFrame">
      <label for="income">Revenus brut global {{ targetYear }}</label>
      <div class="incomeFrame">
        <input id="income"
          type="number"
          v-model="$store.state.income"
          @keyup="isValid()"
          @keydown.enter="goToNext()"
          class="inputFocus"
          :class="{ 'inputError' : !incomeIsValid }"
          placeholder=""
          autocomplete="off"
        >
        <span for="income">€</span>
      </div>
    </div>
    <button @click="goToNext()" class="submit-button" :style="disabled">
      <span class="insivibleSpacer"></span>
      <span>Étape suivante</span>
      <img src="assets/icon/fleche-droite.svg" alt="Étape suivante">
    </button>
    <button @click="$router.push({ name: 'Home' })" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Étape précédente</span>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'

export default {
  name: 'Etape1',
  components: {
    ProgressStep,
  },
  data () {
    return {
      targetYear: new Date().getFullYear() - 2,
      incomeIsValid: true,
      disabled: 'background-color: #C3C4CA'
    }
  },
  mounted () {
    this.$store.state.income !== null && this.isValid()
  },
  methods: {
    goToNext () {
      if (typeof this.$store.state.income === 'number' && this.$store.state.income >= 0) {
        this.$router.push({ name: 'Etape-2' })
      } else {
        this.incomeIsValid = false
      }
    },
    isValid () {
      if (typeof this.$store.state.income === 'number' && this.$store.state.income >= 0) {
        this.incomeIsValid = true
        this.disabled = ''
      } else {
        this.incomeIsValid = false
        this.disabled = 'background-color: #C3C4CA'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  
</style>
